import {Routes} from '@angular/router'
import {CUSTOMERS_ROUTE_PATH, HOME_ROUTE_PATH, LOGIN_ROUTE_PATH} from './application/data-types'
import {InterestResolver} from './application/interest.resolver'
import mainRoutes from './main/main-routes'
import {adminAuthGuard, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'

export const routes: Routes = [
  {
    path: HOME_ROUTE_PATH,
    children: mainRoutes,
    canActivate: [adminAuthGuard],
    resolve: {
      latestInterest: InterestResolver
    }
  },
  {
    path: LOGIN_ROUTE_PATH,
    component: LoginComponent
  },
  {
    path: CUSTOMERS_ROUTE_PATH,
    loadComponent: () => import('./customers/home/customers.component').then(m => m.CustomersComponent),
    canActivate: [adminAuthGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_ROUTE_PATH
  },
  {
    path: '**',
    redirectTo: LOGIN_ROUTE_PATH
  }
]